import {
  Banknote,
  Building2,
  LineChart,
  LayoutDashboard,
  ScanFace,
  TrendingDown,
  TrendingUp,
  UserCheck,
  ArrowLeftRight,
  History,
  Gift,
  Share2,
  Users,
  Trophy,
  MessagesSquare,
  Bot,
  Sparkles,
  Award,
  UserCog,
  Settings,
  Plane,
  Crown,
  type LucideIcon,
} from "lucide-react";

export interface TraderNavItem {
  label: string;
  to: string;
  icon: LucideIcon;
  /** Optional badge text shown on the right (e.g. status count). */
  badge?: string;
}

/**
 * Trader sidebar — mirrors the user-side sections in the operations manual
 * (1–20). Unfinished routes fall through to a stub page until the
 * feature ships.
 */
export const traderNav: TraderNavItem[] = [
  { label: "Dashboard", to: "/trader/dashboard", icon: LayoutDashboard },
  { label: "My Profile", to: "/trader/profile", icon: UserCog },
  { label: "Banks", to: "/trader/banks", icon: Building2 },
  { label: "Trade Accounts", to: "/trader/accounts", icon: Banknote },
  { label: "Web Trader", to: "/trader/web-trader", icon: LineChart },
  { label: "Trade History", to: "/trader/history", icon: History },
  { label: "Account Settings", to: "/trader/account-settings", icon: Settings },
  { label: "Deposit Funds", to: "/trader/deposit", icon: TrendingUp },
  { label: "Withdraw Funds", to: "/trader/withdraw", icon: TrendingDown },
  { label: "Fund Transfer", to: "/trader/fund-transfer", icon: ArrowLeftRight },
  { label: "Offers", to: "/trader/offers", icon: Gift },
  { label: "Campaigns", to: "/trader/campaigns", icon: Plane },
  { label: "IB Campaigns", to: "/trader/ib-campaigns", icon: Crown },
  { label: "Bonus & Loyalty", to: "/trader/bonus", icon: Sparkles },
  { label: "Become an IB", to: "/trader/become-ib", icon: UserCheck },
  { label: "KYC Verification", to: "/trader/kyc", icon: ScanFace },
  { label: "Support Tickets", to: "/trader/support", icon: MessagesSquare },
];
